import React from 'react';
import { List } from 'src/components/filter-section/components/list';
import {
  InitialFilters,
  SearchFacetType,
} from 'src/areas/search/components/results/types';
import { SearchFacetIntervalRange, SearchFacetListItem } from 'src/types';

type Props = {
  autoFocusSearch?: boolean;
  id: string;
  onFilterOptionToggle: (
    itemId: string | null,
    facetType: string,
    values: (string | number)[]
  ) => void;
  options: (
    | SearchFacetIntervalRange
    | (SearchFacetListItem & {
        value?: string;
      })
  )[];
  selectedFilters: InitialFilters | {};
  showTitle?: boolean;
  title: string;
  type: SearchFacetType;
  useInfiniteScroll?: boolean;
};

const FilterSection = ({
  autoFocusSearch,
  id,
  onFilterOptionToggle,
  options,
  selectedFilters,
  showTitle,
  title,
  type,
  useInfiniteScroll,
}: Props) => {
  switch (type) {
    case SearchFacetType.SEARCH_FACET_LIST: {
      const listOptions = options as (SearchFacetListItem & {
        value: string;
      })[];
      return (
        <List
          id={title}
          title={title}
          useInfiniteScroll={useInfiniteScroll}
          items={listOptions}
          showTitle={showTitle}
          autoFocusSearch={autoFocusSearch}
          hasMore={false}
          search={false}
          multiple
          getSelectedState={(itemId: string) =>
            Boolean(
              selectedFilters[id]?.selected?.find(
                (selectedId: string | null) => selectedId === itemId
              )
            )
          }
          onClickItem={onFilterOptionToggle}
        />
      );
    }
    default:
      return null;
  }
};

export default FilterSection;
